import type { UiTagType } from "@shared/components/UiTag/index.vue";

export interface BrandListApiItem {
    id: string;
    logo?: string;
    name: string;
    corpId: string;
    corpName: string;
    admissionStatus: number;
    admissionStatusLabel: string;
    authStatus: number;
    authStatusLabel: string;
    creatorUid: string;
    creatorName: string;
    remark?: string;
    createTime?: string;
    updateTime?: string;
    storeAuths: unknown[];
}

export interface BrandRow {
    brandId: string;
    logo: string;
    name: string;
    admissionStatus: number;
    admissionStatusLabel: string;
    authStatus: number;
    authStatusLabel: string;
    creatorName: string;
    createTime: string;
    updateTime: string;
}

export const ADMISSION_STATUS_OPTIONS = [
    { label: "通过", value: 1 },
    { label: "不通过", value: 2 },
];

export const AUTH_STATUS_OPTIONS = [
    { label: "已授权", value: 1 },
    { label: "未授权", value: 2 },
];

export function getAdmissionStatusTagType(status: number): UiTagType {
    if (status === 1) return "success";
    if (status === 2) return "error";
    return "neutral";
}

export function getAuthStatusTagType(status: number): UiTagType {
    if (status === 1) return "success";
    if (status === 2) return "warning";
    return "neutral";
}

export function mapBrandItemToRow(item: BrandListApiItem): BrandRow {
    return {
        brandId: item.id,
        logo: item.logo || "",
        name: item.name || "--",
        admissionStatus: item.admissionStatus,
        admissionStatusLabel: item.admissionStatusLabel || "--",
        authStatus: item.authStatus,
        authStatusLabel: item.authStatusLabel || "--",
        creatorName: item.creatorName || "--",
        createTime: item.createTime || "--",
        updateTime: item.updateTime || "--",
    };
}
